export default {
    props: {
        yAxisAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'yAxis.axisCrossingValue'
        }, 
        yAxisBackground: {
            type: String,
            kComposite: 'yAxis.background'
        }, 
        yAxisBaseUnit: {
            type: String,
            kComposite: 'yAxis.baseUnit'
        }, 
        yAxisColor: {
            type: String,
            kComposite: 'yAxis.color'
        }, 
        yAxisCrosshairColor: {
            type: String,
            kComposite: 'yAxis.crosshair.color'
        }, 
        yAxisCrosshairOpacity: {
            type: Number,
            kComposite: 'yAxis.crosshair.opacity'
        }, 
        yAxisCrosshairTooltipBackground: {
            type: String,
            kComposite: 'yAxis.crosshair.tooltip.background'
        }, 
        yAxisCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'yAxis.crosshair.tooltip.border.color'
        }, 
        yAxisCrosshairTooltipBorderDashType: {
            type: String,
            kComposite: 'yAxis.crosshair.tooltip.border.dashType'
        }, 
        yAxisCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'yAxis.crosshair.tooltip.border.width'
        }, 
        yAxisCrosshairTooltipColor: {
            type: String,
            kComposite: 'yAxis.crosshair.tooltip.color'
        }, 
        yAxisCrosshairTooltipFont: {
            type: String,
            kComposite: 'yAxis.crosshair.tooltip.font'
        }, 
        yAxisCrosshairTooltipFormat: {
            type: String,
            kComposite: 'yAxis.crosshair.tooltip.format'
        }, 
        yAxisCrosshairTooltipPadding: {
            type: Number,
            kComposite: 'yAxis.crosshair.tooltip.padding'
        }, 
        yAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            kComposite: 'yAxis.crosshair.tooltip.padding.bottom'
        }, 
        yAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            kComposite: 'yAxis.crosshair.tooltip.padding.left'
        }, 
        yAxisCrosshairTooltipPaddingRight: {
            type: Number,
            kComposite: 'yAxis.crosshair.tooltip.padding.right'
        }, 
        yAxisCrosshairTooltipPaddingTop: {
            type: Number,
            kComposite: 'yAxis.crosshair.tooltip.padding.top'
        }, 
        yAxisCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'yAxis.crosshair.tooltip.template'
        }, 
        yAxisCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'yAxis.crosshair.tooltip.visible'
        }, 
        yAxisCrosshairVisible: {
            type: Boolean,
            kComposite: 'yAxis.crosshair.visible'
        }, 
        yAxisCrosshairWidth: {
            type: Number,
            kComposite: 'yAxis.crosshair.width'
        }, 
        yAxisLabelsBackground: {
            type: String,
            kComposite: 'yAxis.labels.background'
        }, 
        yAxisLabelsBorderColor: {
            type: String,
            kComposite: 'yAxis.labels.border.color'
        }, 
        yAxisLabelsBorderDashType: {
            type: String,
            kComposite: 'yAxis.labels.border.dashType'
        }, 
        yAxisLabelsBorderWidth: {
            type: Number,
            kComposite: 'yAxis.labels.border.width'
        }, 
        yAxisLabelsColor: {
            type: String,
            kComposite: 'yAxis.labels.color'
        }, 
        yAxisLabelsCulture: {
            type: String,
            kComposite: 'yAxis.labels.culture'
        }, 
        yAxisLabelsDateFormatsDays: {
            type: String,
            kComposite: 'yAxis.labels.dateFormats.days'
        }, 
        yAxisLabelsDateFormatsHours: {
            type: String,
            kComposite: 'yAxis.labels.dateFormats.hours'
        }, 
        yAxisLabelsDateFormatsMonths: {
            type: String,
            kComposite: 'yAxis.labels.dateFormats.months'
        }, 
        yAxisLabelsDateFormatsWeeks: {
            type: String,
            kComposite: 'yAxis.labels.dateFormats.weeks'
        }, 
        yAxisLabelsDateFormatsYears: {
            type: String,
            kComposite: 'yAxis.labels.dateFormats.years'
        }, 
        yAxisLabelsFont: {
            type: String,
            kComposite: 'yAxis.labels.font'
        }, 
        yAxisLabelsFormat: {
            type: String,
            kComposite: 'yAxis.labels.format'
        }, 
        yAxisLabelsMargin: {
            type: Number,
            kComposite: 'yAxis.labels.margin'
        }, 
        yAxisLabelsMarginBottom: {
            type: Number,
            kComposite: 'yAxis.labels.margin.bottom'
        }, 
        yAxisLabelsMarginLeft: {
            type: Number,
            kComposite: 'yAxis.labels.margin.left'
        }, 
        yAxisLabelsMarginRight: {
            type: Number,
            kComposite: 'yAxis.labels.margin.right'
        }, 
        yAxisLabelsMarginTop: {
            type: Number,
            kComposite: 'yAxis.labels.margin.top'
        }, 
        yAxisLabelsMirror: {
            type: Boolean,
            kComposite: 'yAxis.labels.mirror'
        }, 
        yAxisLabelsPadding: {
            type: Number,
            kComposite: 'yAxis.labels.padding'
        }, 
        yAxisLabelsPaddingBottom: {
            type: Number,
            kComposite: 'yAxis.labels.padding.bottom'
        }, 
        yAxisLabelsPaddingLeft: {
            type: Number,
            kComposite: 'yAxis.labels.padding.left'
        }, 
        yAxisLabelsPaddingRight: {
            type: Number,
            kComposite: 'yAxis.labels.padding.right'
        }, 
        yAxisLabelsPaddingTop: {
            type: Number,
            kComposite: 'yAxis.labels.padding.top'
        }, 
        yAxisLabelsRotation: {
            type: Number,
            kComposite: 'yAxis.labels.rotation'
        }, 
        yAxisLabelsRotationAlign: {
            type: String,
            kComposite: 'yAxis.labels.rotation.align'
        }, 
        yAxisLabelsRotationAngle: {
            type: Number,
            kComposite: 'yAxis.labels.rotation.angle'
        }, 
        yAxisLabelsSkip: {
            type: Number,
            kComposite: 'yAxis.labels.skip'
        }, 
        yAxisLabelsStep: {
            type: Number,
            kComposite: 'yAxis.labels.step'
        }, 
        yAxisLabelsTemplate: {
            type: String | Function,
            kComposite: 'yAxis.labels.template'
        }, 
        yAxisLabelsVisible: {
            type: Boolean,
            kComposite: 'yAxis.labels.visible'
        }, 
        yAxisLabelsVisual: {
            type: Function,
            kComposite: 'yAxis.labels.visual'
        }, 
        yAxisLineColor: {
            type: String,
            kComposite: 'yAxis.line.color'
        }, 
        yAxisLineDashType: {
            type: String,
            kComposite: 'yAxis.line.dashType'
        }, 
        yAxisLineVisible: {
            type: Boolean,
            kComposite: 'yAxis.line.visible'
        }, 
        yAxisLineWidth: {
            type: Number,
            kComposite: 'yAxis.line.width'
        }, 
        yAxisMajorGridLinesColor: {
            type: String,
            kComposite: 'yAxis.majorGridLines.color'
        }, 
        yAxisMajorGridLinesDashType: {
            type: String,
            kComposite: 'yAxis.majorGridLines.dashType'
        }, 
        yAxisMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'yAxis.majorGridLines.visible'
        }, 
        yAxisMajorGridLinesWidth: {
            type: Number,
            kComposite: 'yAxis.majorGridLines.width'
        }, 
        yAxisMajorGridLinesStep: {
            type: Number,
            kComposite: 'yAxis.majorGridLines.step'
        }, 
        yAxisMajorGridLinesSkip: {
            type: Number,
            kComposite: 'yAxis.majorGridLines.skip'
        }, 
        yAxisMinorGridLinesColor: {
            type: String,
            kComposite: 'yAxis.minorGridLines.color'
        }, 
        yAxisMinorGridLinesDashType: {
            type: String,
            kComposite: 'yAxis.minorGridLines.dashType'
        }, 
        yAxisMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'yAxis.minorGridLines.visible'
        }, 
        yAxisMinorGridLinesWidth: {
            type: Number,
            kComposite: 'yAxis.minorGridLines.width'
        }, 
        yAxisMinorGridLinesStep: {
            type: Number,
            kComposite: 'yAxis.minorGridLines.step'
        }, 
        yAxisMinorGridLinesSkip: {
            type: Number,
            kComposite: 'yAxis.minorGridLines.skip'
        }, 
        yAxisMinorTicksColor: {
            type: String,
            kComposite: 'yAxis.minorTicks.color'
        }, 
        yAxisMinorTicksSize: {
            type: Number,
            kComposite: 'yAxis.minorTicks.size'
        }, 
        yAxisMinorTicksVisible: {
            type: Boolean,
            kComposite: 'yAxis.minorTicks.visible'
        }, 
        yAxisMinorTicksWidth: {
            type: Number,
            kComposite: 'yAxis.minorTicks.width'
        }, 
        yAxisMinorTicksStep: {
            type: Number,
            kComposite: 'yAxis.minorTicks.step'
        }, 
        yAxisMinorTicksSkip: {
            type: Number,
            kComposite: 'yAxis.minorTicks.skip'
        }, 
        yAxisMajorTicksColor: {
            type: String,
            kComposite: 'yAxis.majorTicks.color'
        }, 
        yAxisMajorTicksSize: {
            type: Number,
            kComposite: 'yAxis.majorTicks.size'
        }, 
        yAxisMajorTicksVisible: {
            type: Boolean,
            kComposite: 'yAxis.majorTicks.visible'
        }, 
        yAxisMajorTicksWidth: {
            type: Number,
            kComposite: 'yAxis.majorTicks.width'
        }, 
        yAxisMajorTicksStep: {
            type: Number,
            kComposite: 'yAxis.majorTicks.step'
        }, 
        yAxisMajorTicksSkip: {
            type: Number,
            kComposite: 'yAxis.majorTicks.skip'
        }, 
        yAxisMajorUnit: {
            type: Number,
            kComposite: 'yAxis.majorUnit'
        }, 
        yAxisMax: {
            type: Number,
            kComposite: 'yAxis.max'
        }, 
        yAxisMin: {
            type: Number,
            kComposite: 'yAxis.min'
        }, 
        yAxisMinorUnit: {
            type: Number,
            kComposite: 'yAxis.minorUnit'
        }, 
        yAxisName: {
            type: String,
            kComposite: 'yAxis.name'
        }, 
        yAxisNarrowRange: {
            type: Boolean,
            kComposite: 'yAxis.narrowRange'
        }, 
        yAxisPane: {
            type: String,
            kComposite: 'yAxis.pane'
        }, 
        yAxisPlotBands: {
            type: Array,
            kComposite: 'yAxis.plotBands'
        },         yAxisReverse: {
            type: Boolean,
            kComposite: 'yAxis.reverse'
        }, 
        yAxisTitleBackground: {
            type: String,
            kComposite: 'yAxis.title.background'
        }, 
        yAxisTitleBorderColor: {
            type: String,
            kComposite: 'yAxis.title.border.color'
        }, 
        yAxisTitleBorderDashType: {
            type: String,
            kComposite: 'yAxis.title.border.dashType'
        }, 
        yAxisTitleBorderWidth: {
            type: Number,
            kComposite: 'yAxis.title.border.width'
        }, 
        yAxisTitleColor: {
            type: String,
            kComposite: 'yAxis.title.color'
        }, 
        yAxisTitleFont: {
            type: String,
            kComposite: 'yAxis.title.font'
        }, 
        yAxisTitleMargin: {
            type: Number,
            kComposite: 'yAxis.title.margin'
        }, 
        yAxisTitleMarginBottom: {
            type: Number,
            kComposite: 'yAxis.title.margin.bottom'
        }, 
        yAxisTitleMarginLeft: {
            type: Number,
            kComposite: 'yAxis.title.margin.left'
        }, 
        yAxisTitleMarginRight: {
            type: Number,
            kComposite: 'yAxis.title.margin.right'
        }, 
        yAxisTitleMarginTop: {
            type: Number,
            kComposite: 'yAxis.title.margin.top'
        }, 
        yAxisTitlePadding: {
            type: Number,
            kComposite: 'yAxis.title.padding'
        }, 
        yAxisTitlePaddingBottom: {
            type: Number,
            kComposite: 'yAxis.title.padding.bottom'
        }, 
        yAxisTitlePaddingLeft: {
            type: Number,
            kComposite: 'yAxis.title.padding.left'
        }, 
        yAxisTitlePaddingRight: {
            type: Number,
            kComposite: 'yAxis.title.padding.right'
        }, 
        yAxisTitlePaddingTop: {
            type: Number,
            kComposite: 'yAxis.title.padding.top'
        }, 
        yAxisTitlePosition: {
            type: String,
            kComposite: 'yAxis.title.position'
        }, 
        yAxisTitleRotation: {
            type: Number,
            kComposite: 'yAxis.title.rotation'
        }, 
        yAxisTitleText: {
            type: String,
            kComposite: 'yAxis.title.text'
        }, 
        yAxisTitleVisible: {
            type: Boolean,
            kComposite: 'yAxis.title.visible'
        }, 
        yAxisTitleVisual: {
            type: Function,
            kComposite: 'yAxis.title.visual'
        }, 
        yAxisType: {
            type: String,
            kComposite: 'yAxis.type'
        }, 
        yAxisVisible: {
            type: Boolean,
            kComposite: 'yAxis.visible'
        }, 
        yAxisNotesPosition: {
            type: String,
            kComposite: 'yAxis.notes.position'
        }, 
        yAxisNotesIconBackground: {
            type: String,
            kComposite: 'yAxis.notes.icon.background'
        }, 
        yAxisNotesIconBorderColor: {
            type: String,
            kComposite: 'yAxis.notes.icon.border.color'
        }, 
        yAxisNotesIconBorderWidth: {
            type: Number,
            kComposite: 'yAxis.notes.icon.border.width'
        }, 
        yAxisNotesIconSize: {
            type: Number,
            kComposite: 'yAxis.notes.icon.size'
        }, 
        yAxisNotesIconType: {
            type: String,
            kComposite: 'yAxis.notes.icon.type'
        }, 
        yAxisNotesIconVisible: {
            type: Boolean,
            kComposite: 'yAxis.notes.icon.visible'
        }, 
        yAxisNotesLabelBackground: {
            type: String,
            kComposite: 'yAxis.notes.label.background'
        }, 
        yAxisNotesLabelBorderColor: {
            type: String,
            kComposite: 'yAxis.notes.label.border.color'
        }, 
        yAxisNotesLabelBorderDashType: {
            type: String,
            kComposite: 'yAxis.notes.label.border.dashType'
        }, 
        yAxisNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'yAxis.notes.label.border.width'
        }, 
        yAxisNotesLabelColor: {
            type: String,
            kComposite: 'yAxis.notes.label.color'
        }, 
        yAxisNotesLabelFont: {
            type: String,
            kComposite: 'yAxis.notes.label.font'
        }, 
        yAxisNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'yAxis.notes.label.template'
        }, 
        yAxisNotesLabelVisible: {
            type: Boolean,
            kComposite: 'yAxis.notes.label.visible'
        }, 
        yAxisNotesLabelRotation: {
            type: Number,
            kComposite: 'yAxis.notes.label.rotation'
        }, 
        yAxisNotesLabelFormat: {
            type: String,
            kComposite: 'yAxis.notes.label.format'
        }, 
        yAxisNotesLabelPosition: {
            type: String,
            kComposite: 'yAxis.notes.label.position'
        }, 
        yAxisNotesLineDashType: {
            type: String,
            kComposite: 'yAxis.notes.line.dashType'
        }, 
        yAxisNotesLineWidth: {
            type: Number,
            kComposite: 'yAxis.notes.line.width'
        }, 
        yAxisNotesLineColor: {
            type: String,
            kComposite: 'yAxis.notes.line.color'
        }, 
        yAxisNotesLineLength: {
            type: Number,
            kComposite: 'yAxis.notes.line.length'
        }, 
        yAxisNotesData: {
            type: Array,
            kComposite: 'yAxis.notes.data'
        },         yAxisNotesVisual: {
            type: Function,
            kComposite: 'yAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/YAxis.js